export interface AzureTokenResult {
    /**
     * Azure token for the signed in user.
     */
    token: string;

    /**
     * The signed in username.
     */
    aadUserName: string;
}
